import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck, Package, ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { TRIP_STATUS, PAY_STATUS, fmtDateTime } from "@/lib/util";
import { BackBar, Loader, Empty, Money, Pill, tripColor, payColor } from "@/components/common";
import { tr as t } from "@/lib/i18n";

export const TripCard = ({ t: trip, to }) => (
  <Link to={to} data-testid={`trip-card-${trip.number}`} className="card p-4 flex gap-4 items-center active:scale-[0.99] transition-transform">
    <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 ${trip.service_type === "tow" ? "bg-blue-50 text-blue-700" : "bg-sky-50 text-sky-700"}`}>
      {trip.service_type === "tow" ? <Truck className="w-8 h-8" /> : <Package className="w-8 h-8" />}
    </div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="ltr font-black">{trip.number}</span>
        <Pill color={tripColor(trip.status)}>{t(TRIP_STATUS[trip.status])}</Pill>
      </div>
      <div className="text-slate-600 truncate"><bdi>{trip.pickup}</bdi> ← <bdi>{trip.dropoff}</bdi></div>
      <div className="flex items-center gap-2 text-sm mt-1 flex-wrap">
        <Money fils={trip.price_fils} className="text-slate-900" />
        <Pill color={payColor(trip.payment_status)}>{t(PAY_STATUS[trip.payment_status])}</Pill>
        <span className="text-slate-400">{fmtDateTime(trip.created_at)}</span>
      </div>
    </div>
    <ChevronLeft className="w-6 h-6 text-slate-400 shrink-0 ltr:rotate-180" />
  </Link>
);

export default function MyTrips() {
  const [items, setItems] = useState(null);
  const [tab, setTab] = useState("open");
  useEffect(() => { api.get("/trips").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  const list = (items || []).filter((x) => (tab === "open" ? x.status !== "delivered" : x.status === "delivered"));
  return (
    <div>
      <BackBar title={t("نقلاتي")} to="/driver" />
      <div className="p-4 space-y-4">
        <div className="grid grid-cols-2 gap-2 bg-white p-1.5 rounded-2xl border">
          {[["open", "قيد التنفيذ"], ["done", "المنتهية"]].map(([k, l]) => (
            <button key={k} data-testid={`trips-tab-${k}`} onClick={() => setTab(k)}
              className={`h-12 rounded-xl font-bold text-lg ${tab === k ? "bg-blue-700 text-white" : "text-slate-600"}`}>{t(l)}</button>
          ))}
        </div>
        {items === null ? <Loader /> : list.length === 0 ? <Empty icon={Truck} text={t("لا توجد نقلات هنا")} /> :
          <div className="space-y-3">{list.map((x) => <TripCard key={x.id} t={x} to={`/driver/trips/${x.id}`} />)}</div>}
      </div>
    </div>
  );
}
